import { type RelativeRoutingType, useNavigate } from 'react-router-dom';

import useWorkspaceStore from '@/stores/WorkspaceStore';

const useWorkspaceRouter = () => {
  const navigate = useNavigate();
  const wa = useWorkspaceStore((state) => state.currWorkspace)?.alias;

  const push = async (
    path: string,
    options?: {
      replace?: boolean;
      state?: any;
      preventScrollReset?: boolean;
      relative?: RelativeRoutingType;
      unstable_flushSync?: boolean;
      unstable_viewTransition?: boolean;
    },
  ) => {
    navigate(`/workspace/${wa}${path}`, options);
  };

  return {
    push,
    navigate,
  };
};

export default useWorkspaceRouter;
